<template>
  <section class="nightv2-wrapper">
    <div class="nightv2">
        <div class="nightv2__title"></div>

        <div class="nightv2__video-wrapper">
          <div class="nightv2__video">
            <video class="video" :src="$store.getters.getIsMobile ? require('@/assets/abtest/video-mobile.mp4') : require('@/assets/abtest/video.mp4')" poster="~@/assets/abtest/images/poster.png" autoplay loop playsinline muted></video>
          </div>
        </div>
        
        <div class="play-now-wrapper">
            <div class="play-now-button" @click="playFree" @mouseover="playNowHover = true" @mouseleave="playNowHover = false">
              <img :src="playNowHover ? require('@/assets/abtest/images/play-free-now-hover.png') : require('@/assets/abtest/images/play-free-now.png')" alt="play free now">
            </div>
          <div class="play-now-platform">
          </div>
        </div>
        <button @click="$store.dispatch('setScene', 'village')" class="discover-more"></button>

    </div>
  </section>
</template>

<script>
import Util from '@/services/browser/Util'

export default {
  data() {
    return {
      playNowHover: false,
    };
  },

  computed: {
    sceneName () {
      return this.$store.getters.getSceneName
    }
  },

  mounted() {
    this.$gtm.trackEvent({
      'event': 'View Landing Page Section',
      'lp_section': this.sceneName,
      'lp_loc': '0'
    })
  },

  methods: {
    playFree: function (e) {
      e.preventDefault()
      this.$gtm.trackEvent({
        event: 'Play Free Now Click',
        lp_section: 'Armed and Adorable Special',
      })
      Util.playFree()
    },
  }
}
</script>

<style lang="scss" scoped>
  .nightv2-wrapper {
    position: relative;
    background-image: url('~@/assets/abtest/images/bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow: hidden;
    z-index: 0;
    &::before, &:after {
      display: block;
      content: '';
      pointer-events: none;
      position: absolute;
      bottom: 0;
      z-index: 1;
      background-size: contain;
      background-repeat: no-repeat;
      max-width: 64%;
    }
    &:before {
      background-image: url('~@/assets/abtest/images/clouds-left.png');
      background-position: bottom left;
      width: 763px;
      height: 465px;
      left: 0;
    }
    &:after {
      background-image: url('~@/assets/abtest/images/clouds-right.png');
      background-position: bottom right;
      width: 843px;
      height: 540px;
      right: 0;
    }

    @media only screen and (max-width: 600px) and (orientation: portrait) {
      background-position: 20% bottom;
      &:before, &:after {
        content: none;
      }
    }

    .nightv2 {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      position: relative;
      width: 100%;
      height: 100%;

      &__title {
        width: 590px;
        height: 193px;
        max-width: 80%;
        max-height: 30%;
        background-image: url('~@/assets/abtest/images/armed-adorable.png');
        background-size: contain;
        background-position: center top;
        background-repeat: no-repeat;
        position: absolute;
        top: 75px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;

        @media only screen and (max-height: 440px) and (orientation: landscape) {
          top: 60px;
        }

        @media only screen and (max-height: 375px) and (orientation: landscape) {
          top: 50px;
        }

        @media only screen and (max-width: 600px) and (orientation: portrait) {
          top: 10%;
        }
      }

      &__video-wrapper {
        position: relative;
        width: 70%;
        margin-bottom: 8%;
        margin-top: 20px;
        border-radius: 15px;
        box-shadow: 0px 0px 20px 5px #000000;
        overflow: hidden;
        will-change: transform;

        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape)  {
          margin-bottom: 14%;
        }

        @media (min-width: 1800px) and (min-height: 920px) {
          width: 65%;
          margin-bottom: 7%;
        }

        @media (min-width: 1800px) and (min-height: 1000px) {
          width: 74%;
          margin-bottom: 170px;
        }

        @media only screen and (max-width: 1300px) and (orientation: portrait) {
          width: 91%;
          margin-bottom: 30%;
        }
        
        @media only screen and (max-width: 600px) and (orientation: portrait) {
          width: 91%;
          margin-top: 40%;
          margin-bottom: auto;
        }
      }

      &__video {
        width: 100%;
        padding-top: 56.25%;
        height: 0px;
        position: relative;
        .video {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      .play-now-wrapper {
        width: 92%;
        max-width: 954px;
        z-index: 2;
        position: absolute;
        bottom: 2px;
        left: 50%;
        transform: translateX(-50%);

        .play-now-button {
          position: absolute;
          bottom: 30%;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
          width: 100%;
          img {
            max-width: 100%;
            height: auto;
            @media (min-width: 960px) {
              margin-left: 8px;
            }
          }

          &:after {
            display: block;
            content: '';
            width: 152px;
            height: 162px;
            position: absolute;
            right: -35px;
            bottom: 12%;
            background-image: url('~@/assets/abtest/images/ben.gif');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            z-index: 1;
            pointer-events: none;

            @media only screen and (max-width: 1036px) {
              height: 120px;
              width: 120px;
              right: -2%;
              bottom: 14%;
            }

            @media only screen and (max-width: 950px) {
              height: 110px;
              width: 110px;
              right: -2%;
              bottom: 15%;
            }

            @media only screen and (max-width: 900px) {
              right: -3%;
            }

            @media only screen and (max-width: 799px) {
              right: -2%;
              bottom: 14%;
            }

            @media only screen and (max-width: 750px) {
              height: 100px;
              width: 100px;
              bottom: 16%;
            }

            @media only screen and (max-width: 700px) {
              right: -3%;
              bottom: 12%;
            }

            @media only screen and (max-width: 650px) {
              height: 90px;
              width: 90px;
              right: -2.5%;
            }
            
            @media only screen and (max-width: 600px) {
              right: -3.5%;
            }

            @media only screen and (max-width: 550px) {
              height: 80px;
              width: 80px;
              bottom: 14%;
              right: -3%;
            }

            @media only screen and (max-width: 500px) {
              right: -4%;
            }


            @media only screen and (max-width: 450px) {
              height: 70px;
              width: 70px;
            }

            @media only screen and (max-width: 400px) {
              height: 60px;
              width: 60px;
            }
          }

          &:hover {
            cursor: pointer;
          }

          @media only screen and (max-width: 700px) {
            bottom: 38%;
          }

          @media only screen and (max-width: 500px) {
            bottom: 37%;
          }

          @media only screen and (max-width: 450px) {
            bottom: 39%;
          }

          @media only screen and (max-width: 400px) {
            bottom: 40%;
          }

          @media only screen and (max-width: 340px) {
            bottom: 42%;
          }

          @media only screen and (max-width: 320px) {
            bottom: 44%;
          }
        }

        .play-now-platform {
          position: relative;
          width: 100%;
          height: 116px;
          background-image: url('~@/assets/abtest/images/btn-platform.png');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }



        @media only screen and (min-width: 800px) and (max-width: 1024px) and (orientation: landscape) {
          width: 80%;
        }

        @media only screen and (max-height: 440px) and (orientation: landscape) {
          width: 80%;
        }

        @media only screen and (max-height: 400px) and (orientation: landscape) {
          width: 70%;
        }

        @media only screen and (max-width: 600px) and (orientation: portrait) {
          bottom: 20%;
        }

      }


      .discover-more {
        background-image: url('~@/assets/abtest/images/discover-more.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        background-color: transparent;
        border: none;
        width: 285px;
        height: 42px;
        position: absolute;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50px;
        z-index: 2;
        &:hover {
          background-image: url('~@/assets/abtest/images/discover-more-hover.gif');
        }

        @media only screen and (max-width: 600px) and (orientation: portrait) {
          bottom: 40px;
        }

        @media only screen and (max-width: 550px) and (orientation: portrait) {
          width: 240px;
          height: 36px;
        }
      }
    }
  }
</style>